import { useQuery } from '@tanstack/react-query';
import { trackApi } from '@/services/trackService';
import { TrackListParams } from '@/types/track_types';
import { queryKeys } from './queryKeys';

/**
 * Hook to fetch track list with filters
 */
export const useTracks = (params: TrackListParams) => {
  return useQuery({
    queryKey: queryKeys.tracks.list({
      ordering: params.ordering,
      status: params.status,
      page: params.page,
      pageSize: params.page_size,
      search: params.search,
    }),
    queryFn: () => trackApi.getTrackList(params),
    placeholderData: (previousData) => previousData,
  });
};

/**
 * Hook to fetch single track detail
 */
export const useTrackDetail = (trackId: string | undefined, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeys.tracks.detail(Number(trackId)),
    queryFn: () => trackApi.getTrackDetail(trackId!),
    enabled: !!trackId && (options?.enabled ?? true),
  });
};
